import React, {Component} from 'react';
import {Link} from 'components/ReactRouterDomLocalized';

import WishlistItem from './WishlistItem';
import ProfileLink from 'components/ProfileLink';

import {t, dt} from 'l10n';

import 'sass/wishlistuser.scss';
import paths from 'paths';

export default function WishlistUser({user, wishlist}) {
    return (
        <div className="one-list">
            <div className="user">
                <div className="one-list-user-info">
                    <div className="img">
                        <ProfileLink user={user}>
                            <img src={user.avatar_url} alt={user.nick}/>
                        </ProfileLink>
                        {user.online ? <div className="status active"/> : <div className="status"/>}
                    </div>
                    <div className="info-user">
                        <div className="name">
                            {user.gift_rank > 0 && <span className={'star-icon ic-star' + user.gift_rank}></span>}
                            <ProfileLink user={user}/>
                        </div>
                        <Link to={paths.profileWishlist.toPath({nick: user.nick})} className="getAll">{t('View full wishlist')}</Link>
                    </div>
                </div>
            </div>
            {wishlist.map((item, index) => <WishlistItem item={item} key={index}/>)}
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/wishlist/WishlistUser.js